// MLC-WORKFLOW-CONDITIONAL-UI-001 — presentation-only reveal/hide of MLC-dependent fields.
// Children are unmounted once collapsed (no disabled/"Not applicable" placeholders rendered).
import React, { useEffect, useState } from 'react';
import './mlc-collapse.css';

const MS = 220;

export const MlcCollapse = ({ open, className = '', testId = 'mlc-dependent-fields', children }) => {
  const [mounted, setMounted] = useState(!!open);
  useEffect(() => {
    if (open) { setMounted(true); return undefined; }
    const t = setTimeout(() => setMounted(false), MS);
    return () => clearTimeout(t);
  }, [open]);
  return (
    <div className={`mlc-collapse ${open ? 'is-open' : ''} ${className}`} data-testid={testId} data-state={open ? 'open' : 'closed'} aria-hidden={!open}>
      <div className="mlc-collapse-inner">{mounted && children}</div>
    </div>
  );
};

export default MlcCollapse;
